import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface WorkoutSessionContextType {
  isSessionActive: boolean;
  setIsSessionActive: (active: boolean) => void;
  isAnalyzing: boolean;
  setIsAnalyzing: (active: boolean) => void;
}

const WorkoutSessionContext = createContext<WorkoutSessionContextType>({
  isSessionActive: false,
  setIsSessionActive: () => {},
  isAnalyzing: false,
  setIsAnalyzing: () => {},
});

export function WorkoutSessionProvider({ children }: { children: ReactNode }) {
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  return (
    <WorkoutSessionContext.Provider value={{ isSessionActive, setIsSessionActive, isAnalyzing, setIsAnalyzing }}>
      {children}
    </WorkoutSessionContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useWorkoutSession() {
  return useContext(WorkoutSessionContext);
}
